import { Component, Inject, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "../../Login/Service/Login.Service";//"../Service/Login.Service";
import { LoginModel, GeneralBookingModel, FileSearch, UserData } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { CurrencyDetails } from "../../model/utilities/currencydetails";
import { OtpModel } from "../../Model/ServicePayment/OtpModel";
declare var require: any;

@Component({
    selector: 'MentisSoft-Login',
    template: require('../Template/KioskLogin.template.html'),
    styles: [require('../Template/KioskLogin.css')],
    providers: [CurrencyDetails]
})

export class KioskLoginComponent implements AfterViewInit {

    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private route: ActivatedRoute,
        private _LoginService: LoginService, private _titleService: Title,
        @Inject(CurrencyDetails) private _CurrencyDetails: CurrencyDetails) {
    }



    KioskORPortal: string = "KIOSK";
    ngAfterViewInit(): void {
        $('#overlay').hide();
        if (this._SecurityService.errorMessage != "") {
            this.errMsg = this._SecurityService.errorMessage;
        }
        else {
            this.errMsg = "";
        }

    }
    ngOnInit() {       
    }
      
   
    errMsg: string = "";

    GuestAppointment() {
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        this.router.navigate(["/GuestAppointment"]);
    }



    ServicePayment(event) {
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        this.router.navigate(["/SearchServicePayment"]);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/kiosklogin/Component/KioskLogin.Component.ts